import { FieldValidation, CaseFormData, CaseValidation } from 'containers/pages/cases/types';

function validateTitle(value: string): FieldValidation {
	const trimmed = value.trim();
	if (!trimmed) {
		return { isErr: true, errMsg: 'Title is required', canNotSave: true };
	}
	if (trimmed.length < 10) {
		return { isErr: true, errMsg: 'Title must be at least 10 characters', canNotSave: true };
	}
	if (trimmed.length > 100) {
		return { isErr: true, errMsg: 'Title must be 100 characters or fewer', canNotSave: true };
	}
	return { isErr: false, errMsg: '', canNotSave: false };
}

function validateCustomerId(value: number | null): FieldValidation {
	if (!value) {
		return { isErr: true, errMsg: 'Please select a customer', canNotSave: true };
	}
	return { isErr: false, errMsg: '', canNotSave: false };
}

function validateConsultantId(value: number | null): FieldValidation {
	if (!value) {
		return { isErr: true, errMsg: 'Please select a consultant', canNotSave: true };
	}
	return { isErr: false, errMsg: '', canNotSave: false };
}

function validateStatusId(value: string): FieldValidation {
	if (!value) {
		return { isErr: true, errMsg: 'Status is required', canNotSave: true };
	}
	return { isErr: false, errMsg: '', canNotSave: false };
}

export function validateAllFields(form: CaseFormData): CaseValidation {
	return {
		Title: validateTitle(form.Title),
		CustomerId: validateCustomerId(form.CustomerId),
		ConsultantId: validateConsultantId(form.ConsultantId),
		StatusId: validateStatusId(form.StatusId),
	};
}

export { validateTitle, validateCustomerId, validateConsultantId, validateStatusId };
